// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2ynHX","alertIcon":"ConfirmModal_alertIcon__hLtHu"};